export const environment = {
  url: 'https://dev-api-investor.credebt.com/', //InvestorUrl dev url
  credUrl: 'https://dev-api-machine.credebt.com/', //Cred live url
  clientId: '887007fc-4220-4c71-89c3-d9d87cdcfac4',
  authority: 'https://login.microsoftonline.com/7653f2c8-b98b-4cb3-8f2d-4e0b7c7a9e4b',
  TimeOut: 300,
  Idle: 1500,
};
